var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title",class:{'-border' : !_vm.menu}},[_c('div',{staticClass:"page-title__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.menu)?_c('div',{staticClass:"page-title__menu"},_vm._l((_vm.tabs),function(tab,index){return _c('router-link',{key:index,attrs:{"to":{name: tab.name}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',{staticClass:"page-title__menu__item",class:{'-active': isActive},attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(tab.meta.title))])]}}],null,true)})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }